import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/identities/settings/rule-engine')({
  beforeLoad: () => getTitleContextSlice('Rules'),
  staticData: {
    owner: CodeOwner.IDNP,
  },
});
